export default __webpack_public_path__ + "static/media/money.4021ca16.gif";